/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ReferralIdentifierTypeBundle {
    LINK = 'Link',
    VOUCHER = 'Voucher',
    FOLLOW_UP = 'FollowUp',
    TECHNICAL = 'Technical',
}
